import React from 'react';
import styled from 'styled-components';
import Image from 'next/image';

const HowADSCWorks = (props: any) => {
    const { heading, subText, stepIcon, steps } = props;
    return (
        <HowADSCWorksWrapper>
            <HowADSCWorksTexts>
                <HowADSCWorksHeading>{heading}</HowADSCWorksHeading>
                {subText && (
                    <HowADSCWorksSubText>{subText}</HowADSCWorksSubText>
                )}
            </HowADSCWorksTexts>
            <HowADSCWorksStepsWrapper>
                {steps.map((step: any) => {
                    return (
                        <StepWrapper>
                            <StepLogoContainer>
                                {stepIcon?.data && (
                                    <Image
                                        src={stepIcon.data.attributes.url}
                                        width={16}
                                        height={16}
                                        alt={'stepIcon'}
                                    />
                                )}
                                <LogoText>{step.title}</LogoText>
                            </StepLogoContainer>
                            <StepText>{step.subText}</StepText>
                        </StepWrapper>
                    );
                })}
            </HowADSCWorksStepsWrapper>
        </HowADSCWorksWrapper>
    );
};

export default HowADSCWorks;

const HowADSCWorksWrapper = styled.div`
    display: flex;
    padding: 20px 16px;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    align-self: stretch;
    background: #000;
`;
const HowADSCWorksTexts = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    align-self: stretch;
`;

const HowADSCWorksHeading = styled.h2`
    color: #fff;
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: -0.1px;
    align-self: stretch;
    margin: 0;
`;

const HowADSCWorksSubText = styled.div`
    color: #a6a6a6;
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    align-self: stretch;
`;

const HowADSCWorksStepsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
`;

const StepWrapper = styled.div`
    display: flex;
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
    border-radius: 12px;
    background: #1e1e1e;
    backdrop-filter: blur(12px);
`;
const StepLogoContainer = styled.div`
    display: flex;
    padding: 8px 16px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 32px;
    background: linear-gradient(225deg, #000 4.46%, #201e20 97.32%);
`;

const LogoText = styled.div`
    color: #fff;
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
`;

const StepText = styled.div`
    color: #a6a6a6;
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    padding: 0 16px;
`;
